import { ColumnComponent } from '../../../models/LessonComponent';
import ColumnEditor from './ColumnEditor';
import ColumnView from './ColumnView';
import React from 'react';
import { useLessonContext } from '../../../models/LessonContext';
import useThemes from '../../../../shared/hooks/useThemes';

export interface ColumnProps {
  component: ColumnComponent;
}

export default function Column(props: ColumnProps) {
  const { mode } = useLessonContext();
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  return (
    <div style={{ fontFamily }}>
      {mode === 'edit' ? (
        <ColumnEditor {...props} />
      ) : (
        <ColumnView {...props} />
      )}
    </div>
  );
}
